import React from "preact/compat";
import { h, Component } from 'preact';
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import wordArt from "../canvas/word-art";
import constants from "../constants";
import util from "../util";
import tinycolor from "tinycolor2";

export default @connect(reduce, actions)
class WordArtShadowControls extends Component {
  constructor() {
    super();

    this.shadowOff = () => {
      const $element = this.props.$element;
      if (!$element) return;
      $element.attr('data-text-shadowed', "false");
      this.props.updateElementAttribute('textShadowed', false);
      wordArt.removeShadow($element);
    }

    this.shadowOn = () => {
      const $element = this.props.$element;
      if (!$element) return;

      $element.attr('data-text-shadowed', "true");
      this.props.updateElementAttribute('textShadowed', true);
      let color = this.props.textShadowColor;
      if (!color) {
        color = tinycolor($element.css('color')).toHexString();
        $element.attr('data-shadow-color', color);
        this.props.updateElementAttribute('textShadowColor', color);
      }
      wordArt.applyShadow($element, this.props.textShadowOffset, this.props.textShadowDirection, this.props.textShadowBlur, this.props.textShadowOpacity/100, color);
    }

    this.updateShadowOffset = (ev) => {
      const $element = this.props.$element;
      if (!$element) return;

      let val = ev.target.value;
      $element.attr('data-shadow-offset', val);
      this.props.updateElementAttribute('textShadowOffset', val);
      wordArt.applyShadow($element, val, this.props.textShadowDirection, this.props.textShadowBlur, this.props.textShadowOpacity/100, this.props.textShadowColor);
    };

    this.updateShadowDirection = (ev) => {
      const $element = this.props.$element;
      if (!$element) return;

      let val = ev.target.value;
      $element.attr('data-shadow-direction', val);
      this.props.updateElementAttribute('textShadowDirection', val);
      wordArt.applyShadow($element, this.props.textShadowOffset, val, this.props.textShadowBlur, this.props.textShadowOpacity/100, this.props.textShadowColor);
    };

    this.updateShadowBlur = (ev) => {
      const $element = this.props.$element;
      if (!$element) return;

      let val = ev.target.value;
      $element.attr('data-shadow-blur', val);
      this.props.updateElementAttribute('textShadowBlur', val);
      wordArt.applyShadow($element, this.props.textShadowOffset, this.props.textShadowDirection, val, this.props.textShadowOpacity/100, this.props.textShadowColor);
    };

    this.updateShadowOpacity = (ev) => {
      const $element = this.props.$element;
      if (!$element) return;

      let val = ev.target.value;
      $element.attr('data-shadow-opacity', val);
      this.props.updateElementAttribute('textShadowOpacity', val);
      wordArt.applyShadow($element, this.props.textShadowOffset, this.props.textShadowDirection, this.props.textShadowBlur, val/100, this.props.textShadowColor);
    }

    this.updateShadowColor = () => {
      const $element = this.props.$element;
      if (!$element) return;
      util.openColorPicker(constants.pickerTypes.textShadow, true);
    }
  }

  render(props, state) {
    const isTextShadow = props.$element && props.textShadowed;

    return (
      <div className="curve-controls">
        <div className="title">Shadow</div>
        <div className="separator" />
        <ul className="curve-toggles">
          <li className={isTextShadow ? '' : 'act'} onClick={() => this.shadowOff()}>
            <div className="unshadow-text">Aa</div>
            <div className="label">None</div>
          </li>
          <li className={isTextShadow ? 'act' : ''} onClick={() => this.shadowOn()}>
            <div className="shadow-text">Aa</div>
            <div className="label">Shadow</div>
          </li>
        </ul>

        <ul className="slider-list" style={!isTextShadow ? "visibility: hidden;" : ""}>
          <li className="slider-item">
            <label>Offset</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="0" max="40" step="1" value={props.textShadowOffset} onChange={this.updateShadowOffset.bind(this)}
                onMouseMove={(ev) => this.updateShadowOffset(ev)} />
            </div>
            <input className="value" type="number" min="0" max="40" step="1" disabled="disabled" value={props.textShadowOffset} />
          </li>

          <li className="slider-item">
            <label>Direction</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="-180" max="180" step="1" value={props.textShadowDirection} onChange={this.updateShadowDirection.bind(this)}
                onMouseMove={(ev) => this.updateShadowDirection(ev)} />
            </div>
            <input className="value" type="number" min="-180" max="180" step="1" disabled="disabled" value={props.textShadowDirection} />
          </li>

          <li className="slider-item">
            <label>Blur</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="0" max="20" step="1" value={props.textShadowBlur} onChange={this.updateShadowBlur.bind(this)}
                onMouseMove={(ev) => this.updateShadowBlur(ev)} />
            </div>
            <input className="value" type="number" min="0" max="20" step="1" disabled="disabled" value={props.textShadowBlur} />
          </li>

          <li className="slider-item">
            <label>Opacity</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="0" max="100" step="1" value={props.textShadowOpacity} onChange={this.updateShadowOpacity.bind(this)}
                onMouseMove={(ev) => this.updateShadowOpacity(ev)} />
            </div>
            <input className="value" type="number" min="0" max="100" step="1" disabled="disabled" value={props.textShadowOpacity} />
          </li>

          <li className="slider-item color-wrap">
            <label>Color</label>
            <a onClick={() => this.updateShadowColor()}>
              <span className="color-box" style={`background: ${props.textShadowColor}; float: none;`}></span>
            </a>
          </li>
        </ul>
      </div>)
  }
}
